import React from "react";
import { Typography } from "@mui/material";
import ResponsiveDrawer from "views/components/ResponsiveDrawer";

function Links() {
  return (
    <ResponsiveDrawer>
      <div style={{ maxWidth: "calc(100vw - 48px)" }}>
        <Typography paragraph>関連リンク</Typography>
        <ul>
          <li>
            <a
              rel="noopener noreferrer"
              href="https://wakanmoview.inm.u-toyama.ac.jp/kampo/"
              target="_blank"
            >
              KampoDB - 富山大学和漢医薬学総合研究所
            </a>
            <br />
            <Typography variant="caption" color="textSecondary">
              漢方処方の化合物、タンパク質、パスウェイ情報を提供するデータベース
            </Typography>
          </li>
          <li>
            <a
              rel="noopener noreferrer"
              href="https://wakanmoview.inm.u-toyama.ac.jp/kampo/api/"
              target="_blank"
            >
              KampoDB API - Web API Manual
            </a>
            <br />
            <Typography variant="caption" color="textSecondary">
              KampoDB APIの使用方法とエンドポイント情報
            </Typography>
          </li>
          <li>
            <a
              rel="noopener noreferrer"
              href="https://www.mhlw.go.jp/seisakunitsuite/bunya/kenkou_iryou/iyakuhin/topics/dl/tp150401-01-02.pdf"
              target="_blank"
            >
              薬局製剤指針 - 厚生労働省
            </a>
          </li>
          <li>
            <a
              rel="noopener noreferrer"
              href="https://www.mhlw.go.jp/file/06-Seisakujouhou-11120000-Iyakushokuhinkyoku/0000160072.pdf"
              target="_blank"
            >
              一般用漢方製剤製造販売承認基準 - 厚生労働省
            </a>
          </li>
        </ul>
      </div>
    </ResponsiveDrawer>
  );
}

export default Links;
